export const APOLLO_GRAPHQL = '[APOLLO_GRAPHQL]';

export const GRAPHQL_GET_USER_SUCCESS = `${APOLLO_GRAPHQL} GET USER SUCCESS`;
export const addUserToRedux = (user) => ({
	type: GRAPHQL_GET_USER_SUCCESS,
	response: { user },
});

export const GRAPHQL_GET_PROFILE_SUCCESS = `${APOLLO_GRAPHQL} GET PROFILE SUCCESS`;
export const addProfileToRedux = (profile) => ({
	type: GRAPHQL_GET_PROFILE_SUCCESS,
	response: { profile },
});

export const GRAPHQL_GET_ACCOUNTS_SUCCESS = `${APOLLO_GRAPHQL} GET ACCOUNTS SUCCESS`;
export const addAccountsToRedux = (accounts) => ({
	type: GRAPHQL_GET_ACCOUNTS_SUCCESS,
	response: { accounts },
});

export const GRAPHQL_GET_FUNDING_SOURCES_SUCCESS = `${APOLLO_GRAPHQL} GET FUNDING SOURCES`;
export const addFundingSourcesRedux = (funding_sources) => ({
	type: GRAPHQL_GET_FUNDING_SOURCES_SUCCESS,
	response: { funding_sources },
});

export const GRAPHQL_GET_INVESTOR_APPLICATION_SUCCESS = `${APOLLO_GRAPHQL} GET INVESTOR APPLICATION SUCCESS`;
export const addInvestorApplicationToRedux = (investor_application) => ({
	type: GRAPHQL_GET_INVESTOR_APPLICATION_SUCCESS,
	response: { investor_application },
});

export const GRAPHQL_GET_TRUSTED_CONTACT_SUCCESS = `${APOLLO_GRAPHQL} GET TRUSTED CONTACT SUCCESS`;
export const addTrustedContactToRedux = (trusted_contact) => ({
	type: GRAPHQL_GET_TRUSTED_CONTACT_SUCCESS,
	response: { trusted_contact },
});

export const GRAPHQL_GET_ELIGIBLE_ACCOUNT_TYPES_SUCCESS = `${APOLLO_GRAPHQL} GET ELIGIBLE ACCOUNT TYPES SUCCESS`;
export const addEligibleAccountTypesToRedux = (eligible_account_types) => ({
	type: GRAPHQL_GET_ELIGIBLE_ACCOUNT_TYPES_SUCCESS,
	response: { eligible_account_types },
});

export const GRAPHQL_GET_ONBOARDING_QUESTIONS_SUCCESS = `${APOLLO_GRAPHQL} GET ONBOARDING QUESTIONS SUCCESS`;
export const addOnboardingQuestionsToRedux = (onboarding_questions) => ({
	type: GRAPHQL_GET_ONBOARDING_QUESTIONS_SUCCESS,
	response: { response: onboarding_questions },
});

export const GRAPHQL_GET_ONBOARDING_QUESTIONS_ANSWERS_SUCCESS = `${APOLLO_GRAPHQL} GET ONBOARDING QUESTIONS ANSWERS SUCCESS`;
export const addOnboardingQuestionsAnswersToRedux = (onboarding_questions_answers) => {
	const {
		financial_profile_question_1,
		financial_profile_question_2,
		financial_profile_question_3,
		financial_profile_question_4,
		...restQuestionsAnswers
	} = onboarding_questions_answers.questions;

	return {
		type: GRAPHQL_GET_ONBOARDING_QUESTIONS_ANSWERS_SUCCESS,
		response: {
			...onboarding_questions_answers,
			questions: {
				...restQuestionsAnswers,
				'financial-profile-question-1': financial_profile_question_1,
				'financial-profile-question-2': financial_profile_question_2,
				'financial-profile-question-3': financial_profile_question_3,
				'financial-profile-question-4': financial_profile_question_4,
			},
		},
	};
};

export const GRAPHQL_GET_CART_ITEMS_SUCCESS = `${APOLLO_GRAPHQL} GET CART ITEMS SUCCESS`;
export const addCartItemsToRedux = (cart_items_with_cards) => ({
	type: GRAPHQL_GET_CART_ITEMS_SUCCESS,
	response: { cart_items_with_cards },
});
